import Vue from 'vue'
import Vuex from 'vuex'
import state from './states/index'
import mutations from './mutations/index'


Vue.use(Vuex)



export default new Vuex.Store({
    state,
    mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js